import { Col, Form, Select } from "antd";
import CustomDatePicker from "common/CustomDatePicker";
import moment from "moment";
import { useEffect, useState } from "react";
import {
  GET_BUYER_ENDPOINT,
  GET_BUYING_OFFICE_ENDPOINT,
  SALES_CONTRACT_LIST,
  STYLE_MERCHANDISING_LIST,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";

const ProductionDetailsFilterFileds = ({ initialTableData }) => {
  // States
  const [salesContractList, setSalesContractList] = useState([]);
  const [styleList, setStyleList] = useState([]);
  const [buyingOfficeList, setBuyingOfficeList] = useState([]);
  const [buyerList, setBuyerList] = useState([]);

  // current path
  const currentPath = window.location.pathname;

  // UX sweep default: this Form.Item's "start_date" is shared by two pages via the
  // "production_details" filterName. ProductionTracking (/report/report-production-tracking)
  // hides the field entirely and wants no date default ("all open orders"); ProductionDetails
  // (/report/report-production-details) has this as its one real, required date and defaults
  // to today. Keyed off the same currentPath check already used for the `hidden` prop below,
  // so ProductionTracking's behaviour is unaffected.
  const defaultStartDate =
    currentPath === "/report/report-production-details"
      ? moment().format("YYYY-MM-DD")
      : undefined;

  // Antd
  const { Option } = Select;

  useEffect(() => {
    getSalesContractList();
    getBuyerList();
    getBuyingOfficeList();
    getStyleList();
  }, []);

  const getSalesContractList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      reference_no: filterValues?.reference_no || "",
    };
    const response = await getData(SALES_CONTRACT_LIST, false, bodyData);

    if (response && response?.data?.code === 200) {
      setSalesContractList(response?.data?.data?.data || []);
    }
  };
  const getStyleList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      style_no: filterValues?.style_no || "",
    };
    const response = await getData(STYLE_MERCHANDISING_LIST, false, bodyData);

    if (response && response?.data?.code === 200) {
      setStyleList(response?.data?.data?.data || []);
    }
  };
  const getBuyerList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      name: filterValues?.name || "",
    };
    const response = await getData(GET_BUYER_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setBuyerList(response?.data?.data?.data || []);
    }
  };
  const getBuyingOfficeList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      name: filterValues?.name || "",
    };
    const response = await getData(GET_BUYING_OFFICE_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setBuyingOfficeList(response?.data?.data?.data || []);
    }
  };

  return (
    <>
      <Col
        span={4}
        hidden={currentPath === "/report/report-production-tracking"}
      >
        <Form.Item
          label="Date"
          name="start_date"
          required
          initialValue={defaultStartDate}
          rules={[
            {
              required: false,
              message: "Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4} hidden={true}>
        <Form.Item label="End Date" name="end_date">
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Sales Contract No" name="sales_contract_id">
          <Select
            showSearch
            placeholder="Select a Sales Contract No"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getSalesContractList({ reference_no: value })}
          >
            {isArrayAndHasValue(salesContractList) &&
              salesContractList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.reference_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Style No." name="style_id">
          <Select
            showSearch
            placeholder="Select a Style"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getStyleList({ style_no: value })}
          >
            {isArrayAndHasValue(styleList) &&
              styleList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.style_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Buying Office" name="buying_office_id">
          <Select
            showSearch
            placeholder="Select a Buying Office"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getBuyingOfficeList({ name: value })}
          >
            {isArrayAndHasValue(buyingOfficeList) &&
              buyingOfficeList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Buyer" name="buyer_id">
          <Select
            showSearch
            placeholder="Select a Buyer"
            optionFilterProp="children"
            size="small"
            onSearch={(value) => getBuyerList({ name: value })}
          >
            {isArrayAndHasValue(buyerList) &&
              buyerList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default ProductionDetailsFilterFileds;
